exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".responsive-image {\n  width: 100%;\n}\n.responsive-image img {\n  width: 100%;\n}\n", ""]);

// exports
